import React from 'react';

import readingLogo from './GroupReading.jpg';
import RIFLogo from './RIF_Logo.png';
import imaginationLibraryLogo from './ImaginationLibrary_Logo.png';

export const HARRY_MOON_LANDING_HERO = 'harryMoonLandingHero';
export const HARRY_MOON_SERIES_HERO = 'harryMoonBookHero';
export const HARRY_MOON_MEDIA_TYPE = 'harryMoonLanding';

export const PARTNERSHIPS_AND_RESOURCES = [
  {
    description: (
      <span>
        <a href="https://www.rif.org/" target="blank">
          Reading is Fundamental
        </a>{' '}
        provides children with books of their own as well as additional
        materials for enhanced literacy engagement in order to inspire a passion
        for reading in young children that will serve them for the rest of their
        lives.
      </span>
    ),
    imageUrl: RIFLogo,
  },
  {
    description: (
      <span>
        With{' '}
        <a href=" https://imaginationlibrary.com/" target="blank">
          Imagination Library
        </a>{' '}
        , children will receive free books from birth until they enter school at
        age 5. This organization hopes to foster a love of reading early on in
        hopes that children will carry it with them as they enter school.
      </span>
    ),
    imageUrl: imaginationLibraryLogo,
  },
  {
    description: (
      <span>
        Many children prefer to read independently but{' '}
        <a
          href="https://www.scholastic.com/teachers/articles/teaching-content/4-tips-guided-reading-success/"
          target="blank"
        >
          reading as a group
        </a>{' '}
        also offers a variety of benefits for literacy engagement. Check out
        these tips for guided reading groups which can help enhance your
        students’ reading experience!
      </span>
    ),
    imageUrl: readingLogo,
  },
];
